const QUERY_PARAMS = Object.freeze({
  SHOW_SECONDARY_NAV: `showSecondaryNav`,
})

export default QUERY_PARAMS
